import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../Containers/Config/index.js';
import { PAYMENT_FAILURE_PAIN_MINUTES, PAYMENT_FAILURE_PAIN_MINUTES_ERROR, PAYMENT_FAILURE_PAIN_MINUTES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* paymentFailurePainMinutes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: PAYMENT_FAILURE_PAIN_MINUTES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: PAYMENT_FAILURE_PAIN_MINUTES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PAYMENT_FAILURE_PAIN_MINUTES_ERROR, payload: error });
  }
}

export function* watchPaymentFailurePainMinutes() {
  yield takeEvery(PAYMENT_FAILURE_PAIN_MINUTES, paymentFailurePainMinutes);
}

function* paymentFailurePainMinutesSaga() {
  yield all([fork(watchPaymentFailurePainMinutes)]);
}

export default paymentFailurePainMinutesSaga;
